import React, {Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";

import {createLike, deleteLike} from "../../../creators/like";

import Icon from "../Icon";
import Modal from "../Modal";
// import SignIn from "../../pages/Signin";
import {fetchLikes} from "../../../creators/likes";
import {Can} from "../../../ability-context";
// import EmailValidation from "../SignUpInformation/components/EmailValidation";
import history from "../../../libs/history";

import EmailValidation from "../SignUpInformation/components/EmailValidation";
import EncourageSignup from "../../components2/encourageSignup/EncourageSignup";

class Like extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            toggleLike: this.props.isLiked || false,
            classActive: false,
            value: this.props.value || 0,
            togglePopup: false,
            toggleModalEmailUnconfirmed : false,
        };
        // this.modal = this.props.clickCta["like"];
        this.handleToggleLike = this.handleToggleLike.bind(this);
    };

    handleToggleLike(e) {
        e.stopPropagation();
        if(this.props.currentUserId){
            let value = this.state.value;
            if (!this.state.toggleLike) {
                this.props.createLike(this.props.likeType, this.props.parentId);
                value++;
            } else {
                this.props.deleteLike(this.props.likeType, this.props.parentId);
                value--;
            }
            this.setState({toggleLike: !this.state.toggleLike, classActive: !this.state.classActive, value});
        }
        // else {
        //     this.setState({toggleSignIn: !this.state.toggleSignIn});
        // }
    }

    render(){
        // let currentModal = this.props.currentUser && this.props.currentUser.email && this.props.currentUser.email.verified ? "toggleSignIn" : "toggleModalEmailUnconfirmed";
        let modal = this.props.clickCta["like"] || {};
        return(
            <Can action="create" subject="Like" passThrough>
                {can => {
                    return can ? (
                        <div
                            className={`likes ${this.state.toggleLike ? 'active' : ''} ${this.state.classActive && 'animate-like'}`}
                            onClick={(e) => this.handleToggleLike(e)}>
                            {this.state.toggleLike ? (
                                <Icon type="heart-full"/>
                            ) : (
                                <Icon type="heart-empty"/>
                            )}

                            {this.state.value || 0}

                            {/*<Modal toggle={this.state.toggleSignIn} handleClose={() => this.setState({toggleSignIn: false})}>*/}
                            {/*    <SignIn isModal={true} handleClose={() => this.setState({toggleSignIn: false})}/>*/}
                            {/*</Modal>*/}
                        </div>
                    ) : (
                        this.props.currentUserInitialized ? (
                            <Fragment>
                                {modal && modal.modal ? (
                                    <Fragment>
                                        <div className={`likes ${this.state.toggleLike ? 'active' : ''} ${this.state.classActive && 'animate-like'}`}  onClick={(e) => this.setState({togglePopup: true})}>
                                            {this.state.toggleLike ? (
                                                <Icon type="heart-full"/>
                                            ) : (
                                                <Icon type="heart-empty"/>
                                            )}
                                            {this.state.value || 0}
                                        </div>
                                        {modal.modal === EmailValidation ? <EmailValidation toggle={this.state.togglePopup} handleClose={() => this.setState({togglePopup: false})} /> : (
                                            <Modal toggle={this.state.togglePopup} handleClose={() => this.setState({togglePopup: false})}>
                                                <modal.modal username={this.props.currentUser.username} userId={this.props.currentUser._id} handleClose={() => this.setState({togglePopup: false})} />
                                            </Modal>
                                        )}

                                    </Fragment>
                                ) : (
                                    <div className={`likes ${this.state.toggleLike ? 'active' : ''} ${this.state.classActive && 'animate-like'}`} onClick={() => modal.to ? history.push(modal.to) : null}>
                                        {this.state.toggleLike ? (
                                            <Icon type="heart-full"/>
                                        ) : (
                                            <Icon type="heart-empty"/>
                                        )}
                                        {this.state.value || 0}
                                    </div>
                                )}
                            </Fragment>
                        ) : (
                            <Fragment>
                                <div className={`likes ${this.state.toggleLike ? 'active' : ''} ${this.state.classActive && 'animate-like'}`} onClick={() => this.setState({togglePopup: true})}>
                                    {this.state.toggleLike ? (
                                        <Icon type="heart-full"/>
                                    ) : (
                                        <Icon type="heart-empty"/>
                                    )}
                                    {this.state.value || 0}
                                </div>
                                <EncourageSignup toggle={this.state.togglePopup} handleClose={() => this.setState({togglePopup: false})} />
                            </Fragment>
                            )
                    )}}
            </Can>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserId: state.currentUser.data && state.currentUser.data._id,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,
        clickCta : state.clickCta.data,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchLikes,

    createLike,
    deleteLike
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Like);